<template>
  <div class="d-flex flex-column align-start">
    <v-btn
      v-for="t in tabs"
      :key="t.value"
      text
      large
      block
      tile
      class="justify-start flex-grow-0 rounded-lg mb-1"
      :class="[ t.value == value && 'oderon lighten-1', eachClass ]"
      @click="$emit('input', t.value)"
    >
      <OCheckIcon radio class="mr-4 opacity-6" :value="t.value == value"/>
      {{ t.text || t.label }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    tabs: { type: Array, required: true },
    value: {},
    eachClass: {},
  }
}
</script>

<style lang="sass"></style>
